export const jsonData = {
  page2: './images/page2/page2.json',
  production: './images/production/production.json'
}
export const imgData = [
  './images/production/production.json',
  './images/lottery/lottery.json',
  './images/tips/tips.json',
  './images/feitan/feitan.json',
  './images/city/city_ani.json',
  './images/yun/yun.json',
  './images/stage/xyw.json',
  './images/stage/bnh.json',
  './images/stage/diygf.json',
  './images/stage/sjbwg.json',
  './images/stage/yycb.json',
  // './images/bg/bg_01.jpg',
  // './images/bg/bg_02.jpg',
  // './images/bg/bg_03.jpg',
  // './images/bg/bg_04.jpg',
  // './images/bg/bg_05.jpg',
  // './images/bg/bg_06.jpg',
  // './images/bg/bg_07.jpg',
  // './images/bg/bg_08.jpg',
  // './images/bg/bg_09.jpg',
  './images/bg/lottery_bg.png',
  './images/yun/yun.png',
  './images/feitan/feitan.png',
  './images/tips/tips.png',
  './images/tips/tip_finger.png',
  './images/tips/tip_finger.json',
  './images/tips/statement.png',
  './images/tips/rule.png',
  './images/tips/logo.json',
  './images/tips/logo.png',
  './images/tips/city_arrow.json',
  './images/tips/city_arrow.png',
  './images/tips/firework.json',
  './images/tips/firework.png',
  './images/lottery/lottery.png',
  './images/production/production.png',
  // './images/city/hangzhou_an.png',
  // './images/city/hangzhou_liang.png',
  // './images/city/guangzhou_an.png',
  // './images/city/guangzhou_liang.png',
  // './images/city/shanghai_an.png',
  // './images/city/shanghai_liang.png',
  // './images/city/chengdu_an.png',
  // './images/city/chengdu_liang.png',
  './images/city/city_ani.png',
  './images/yun_ani/yun_t1-0.png',
  './images/yun_ani/yun_t1-0.json',
  './images/yun_ani/yun_t1-1.png',
  './images/yun_ani/yun_t1-1.json',
  './images/yun_ani/yun_t1-2.png',
  './images/yun_ani/yun_t1-2.json',
  './images/yun_ani/yun_t1-3.png',
  './images/yun_ani/yun_t1-3.json',
  './images/yun_ani/yun_t1-4.png',
  './images/yun_ani/yun_t1-4.json',
  // './images/share_img/bose.png',
  // './images/share_img/beat.png',
  // './images/share_img/deli.png',
  // './images/share_img/dji.png',
  // './images/share_img/fitbit.png',
  // './images/share_img/gopro.png',
  // './images/share_img/huashuo.png',
  // './images/share_img/jimi.png',
  // './images/share_img/lbl.png',
  // './images/share_img/lenovo.png',
  // './images/share_img/mgwj.png',
  // './images/share_img/seagate.png',
  // './images/share_img/thinkpad.png',
  // './images/share_img/three.png',
  // './images/share_img/wjgd.png',
  './images/stage/xyw.png',
  './images/stage/bnh.png',
  './images/stage/diygf.png',
  './images/stage/sjbwg.png',
  './images/stage/yycb.png',
]

export const imgPos = [{
  name: 'arrow',
  json: './images/tips/tips.json',
  type: 'dynamic',
  start: {
    x: 335,
    y: 820
  }
}, {
  name: 'lenovo3',
  json: './images/production/production.json',
  type: 'dynamic',
  com: 'lenovo',
  proUrl: 'https://item.jd.com/100003150683.html',
  start: {
    x: 130,
    y: 1350
  }
}, {
  name: 'lenovo1',
  json: './images/production/production.json',
  type: 'dynamic',
  com: 'lenovo',
  proUrl: 'https://item.jd.com/100005158450.html',
  start: {
    x: 500,
    y: 1300
  }
}, {
  name: 'lenovo2',
  json: './images/production/production.json',
  type: 'static',
  islogo: true,
  direction: 'right',
  shopname: 'lenovo',
  shopUrl: 'https://shop.m.jd.com/?shopId=1000000157',
  addPos: {
    x: 212,
    y: -8
  },
  start: {
    x: 170,
    y: 1540
  }
}, {
  name: 'thinkpad1',
  json: './images/production/production.json',
  type: 'dynamic',
  com: 'thinkpad',
  proUrl: 'https://item.jd.com/100004311524.html',
  start: {
    x: 160,
    y: 2000
  }
}, {
  name: 'thinkpad3',
  json: './images/production/production.json',
  type: 'static',
  islogo: true,
  direction: 'right',
  shopname: 'thinkpad',
  shopUrl: 'https://shop.m.jd.com/?shopId=1000000158',
  addPos: {
    x: 272,
    y: 107
  },
  start: {
    x: 405,
    y: 1968
  }
}, {
  name: 'thinkpad2',
  json: './images/production/production.json',
  com: 'thinkpad',
  proUrl: 'https://item.jd.com/6072622.html',
  type: 'dynamic',
  start: {
    x: 408,
    y: 1770
  }
}, {
  name: 'huashuo2',
  json: './images/production/production.json',
  com: 'huashuo',
  proUrl: 'https://item.jd.com/100003034541.html',
  type: 'dynamic',
  start: {
    x: 103,
    y: 2505
  }
}, {
  name: 'huashuo1',
  json: './images/production/production.json',
  type: 'static',
  islogo: true,
  direction: 'left',
  shopname: 'huashuo',
  shopUrl: 'https://shop.m.jd.com/?shopId=1000000182',
  addPos: {
    x: 188,
    y: 119
  },
  start: {
    x: 38,
    y: 2180
  }
}, {
  name: 'roof',
  json: './images/production/production.json',
  type: 'static',
  start: {
    x: 416,
    y: 3092
  }
}, {
  name: 'bose1',
  json: './images/production/production.json',
  type: 'static',
  com: 'bose',
  proUrl: 'https://item.jd.com/4406782.html',
  start: {
    x: 543,
    y: 2987
  }
}, {
  name: 'bose2',
  json: './images/production/production.json',
  type: 'dynamic',
  com: 'bose',
  proUrl: 'https://item.jd.com/5046941.html',
  start: {
    x: 410,
    y: 3360
  }
}, {
  name: 'bose3',
  json: './images/production/production.json',
  type: 'logo',
  islogo: true,
  direction: 'right',
  shopname: 'bose',
  shopUrl: 'https://shop.m.jd.com/?shopId=1000000331',
  addPos: {
    x: 148,
    y: -45
  },

  start: {
    x: 322,
    y: 3255
  }
}, {
  name: 'beat1',
  json: './images/production/production.json',
  type: 'dynamic',
  com: 'beat',
  proUrl: 'https://item.jd.com/4397372.html',
  start: {
    x: 190,
    y: 3706
  }
}, {
  name: 'beat2',
  json: './images/production/production.json',
  type: 'dynamic',
  com: 'beat',
  proUrl: 'https://item.jd.com/100003116972.html',
  start: {
    x: 25,
    y: 3777
  }
}, {
  name: 'beat3',
  json: './images/production/production.json',
  type: 'dynamic',
  islogo: true,
  direction: 'right',
  shopname: 'beat',
  shopUrl: 'https://shop.m.jd.com/?shopId=1000000290',
  addPos: {
    x: 184,
    y: -5
  },
  start: {
    x: 239,
    y: 4112
  }
}, {
  name: 'lbl1',
  json: './images/production/production.json',
  type: 'dynamic',
  com: 'lbl',
  proUrl: 'https://item.jd.com/100001167712.html',
  start: {
    x: 551,
    y: 4565
  }
}, {
  name: 'lbl2',
  json: './images/production/production.json',
  type: 'static',
  islogo: true,
  direction: 'left',
  shopname: 'lbl',
  shopUrl: 'https://shop.m.jd.com/?shopId=1000000307',
  addPos: {
    x: -10,
    y: -49
  },
  start: {
    x: 579,
    y: 4410
  }
}, {
  name: 'dji1',
  json: './images/production/production.json',
  type: 'dynamic',
  com: 'dji',
  proUrl: 'https://item.jd.com/8731508.html',
  start: {
    x: 90,
    y: 5450
  }
}, {
  name: 'dji2',
  json: './images/production/production.json',
  type: 'dynamic',
  com: 'dji',
  proUrl: 'https://item.jd.com/8731508.html',
  start: {
    x: 87,
    y: 5357
  }
}, {
  name: 'dji3',
  json: './images/production/production.json',
  type: 'dynamic',
  com: 'dji',
  proUrl: 'https://item.jd.com/8731508.html',
  start: {
    x: 183,
    y: 5323
  }
}, {
  name: 'dajiang',
  json: './images/production/production.json',
  type: 'static',
  islogo: true,
  direction: 'left',
  shopname: 'dji',
  shopUrl: 'https://shop.m.jd.com/?shopId=1000002350',
  addPos: {
    x: 59,
    y: -70
  },
  start: {
    x: 205,
    y: 5791
  }
}, {
  name: 'gopro1',
  json: './images/production/production.json',
  type: 'dynamic',
  com: 'gopro',
  proUrl: 'https://item.jd.com/100000538392.html',
  start: {
    x: 273,
    y: 6037
  }
}, {
  name: 'gopro2',
  json: './images/production/production.json',
  type: 'static',
  islogo: true,
  direction: 'center',
  shopname: 'gopro',
  shopUrl: 'https://shop.m.jd.com/?shopId=1000000925',
  addPos: {
    x: 185,
    y: -8
  },
  start: {
    x: 184,
    y: 6171
  }
}, {
  name: 'jimi1',
  json: './images/production/production.json',
  type: 'static',
  islogo: true,
  direction: 'center',
  shopname: 'jimi',
  shopUrl: 'https://shop.m.jd.com/?shopId=1000000582',
  addPos: {
    x: 151,
    y: -26
  },
  start: {
    x: 200,
    y: 6658
  }
}, {
  name: 'jimi2',
  json: './images/production/production.json',
  type: 'static',
  com: 'jimi',
  proUrl: 'https://item.jd.com/7853214.html',
  start: {
    x: 34,
    y: 6431
  }
}, {
  name: 'wjgd2',
  json: './images/production/production.json',
  type: 'static',
  islogo: true,
  direction: 'right',
  shopname: 'wjgd',
  shopUrl: 'https://shop.m.jd.com/?shopId=1000000860',
  addPos: {
    x: 147,
    y: -48
  },
  start: {
    x: 112,
    y: 8126
  }
}, {
  name: 'wjgd1',
  json: './images/production/production.json',
  type: 'dynamic',
  com: 'wjgd',
  proUrl: 'https://item.jd.com/100004852036.html',
  start: {
    x: 80,
    y: 8207
  }
}, {
  name: 'fitbit1',
  json: './images/production/production.json',
  type: 'dynamic',
  com: 'fitbit',
  proUrl: 'https://item.m.jd.com/product/100002098120.html',
  start: {
    x: 475,
    y: 8528
  }
}, {
  name: 'fitbit2',
  json: './images/production/production.json',
  type: 'static',
  islogo: true,
  direction: 'right',
  shopname: 'fitbit',
  shopUrl: 'https://shop.m.jd.com/?shopId=1000001893',
  addPos: {
    x: 49,
    y: -35
  },
  start: {
    x: 503,
    y: 8503
  }
}, {
  name: 'seagate2',
  json: './images/production/production.json',
  type: 'static',
  islogo: true,
  direction: 'left',
  shopname: 'seagate',
  shopUrl: 'https://shop.m.jd.com/?shopId=1000000174',
  addPos: {
    x: 165,
    y: -50
  },
  start: {
    x: 127,
    y: 8944
  }
}, {
  name: 'seagate1',
  json: './images/production/production.json',
  type: 'dynamic',
  com: 'seagate',
  proUrl: 'https://item.jd.com/100002937499.html',
  start: {
    x: 152,
    y: 8764
  }
}, {
  name: 'deli1',
  json: './images/production/production.json',
  type: 'dynamic',
  com: 'deli',
  proUrl: 'https://item.jd.com/6083485.html',
  start: {
    x: 423,
    y: 8852
  }
}, {
  name: 'deli2',
  json: './images/production/production.json',
  type: 'static',
  islogo: true,
  direction: 'right',
  shopname: 'deli',
  shopUrl: 'https://shop.m.jd.com/?shopId=1000001132',
  addPos: {
    x: -5,
    y: -79
  },
  start: {
    x: 601,
    y: 8883
  }
}, {
  name: 'three1',
  json: './images/production/production.json',
  type: 'dynamic',
  com: 'three',
  proUrl: 'https://item.jd.com/100000830211.html',
  start: {
    x: 418,
    y: 9135
  }
}, {
  name: 'three2',
  json: './images/production/production.json',
  type: 'static',
  islogo: true,
  direction: 'right',
  shopname: 'three',
  shopUrl: 'https://shop.m.jd.com/?shopId=1000000834',
  addPos: {
    x: 167,
    y: -20
  },
  start: {
    x: 418,
    y: 9321
  }
}, {
  name: 'mgwj2',
  json: './images/production/production.json',
  type: 'static',
  islogo: true,
  direction: 'left',
  shopname: 'mgwj',
  shopUrl: 'https://shop.m.jd.com/?shopId=1000000827',
  addPos: {
    x: 9,
    y: -35
  },
  start: {
    x: 89,
    y: 9223
  }
}, {
  name: 'mgwj1',
  json: './images/production/production.json',
  type: 'dynamic',
  com: 'mgwj',
  proUrl: 'https://item.jd.com/5334855.html',
  start: {
    x: 134,
    y: 9350
  }
}]
